export const CLASS_NAMES = {
  QUIZ_RESULT: 'quiz-result',
} as const;
